import { SvgSprite } from './modules/svg-loader';
import { RevealPanel } from './modules/revealPanel';
import { Accordion } from './modules/accordion';
import { Tabs } from './modules/tabs';
import { mainNavigation } from './modules/mainNavigation';
import { GoogleTranslate } from './modules/google-translate'
import * as YouTubeIframeLoader from 'youtube-iframe';
import { Gallery } from './modules/gallery';
import { QuickDonate } from './modules/quickDonate';
import { HeaderVideo } from './modules/headerVideo';
import { VideoItem } from './modules/videoItem';
import { initializeOttVideos } from './modules/ottVideo';
import { Modal } from './modules/a11y-modal';
import { AudioPlayer } from './modules/audioPlayer';
import { FilterAppInit } from './modules/filter/index';
import { WordflyModal } from './modules/wordfly-modal';
import { VideoPosterItem } from './modules/videoPosterItem';
import { privacyAlert } from './modules/privacyAlert';

new SvgSprite('/Static/img/adage-sprite.svg');

new GoogleTranslate();

/**
 * Initialize video items on the page.
 * Call this function after dynamically adding video elements to the DOM.
 * Uses data-video-initialized attribute to prevent re-initializing the same element.
 */
export const initializeVideoItems = () => {
    // Gated Vimeo OTT placeholders fetch their authorized iframe from the server.
    initializeOttVideos();

    // Find video items that haven't been initialized yet (excluding YouTube which has separate init)
    const videoItems = Array.prototype.slice.call(
        document.querySelectorAll('[data-video-item]:not([data-video-type=youtube]):not([data-video-initialized])')
    ) as HTMLElement[];

    const youtubeVideoItems = Array.prototype.slice.call(
        document.querySelectorAll('[data-video-item][data-video-type=youtube]:not([data-video-initialized])')
    ) as HTMLElement[];

    // Initialize non-YouTube videos
    videoItems.forEach(videoItem => {
        videoItem.setAttribute('data-video-initialized', 'true');
        new VideoItem(videoItem);
    });

    // Initialize YouTube videos
    if (youtubeVideoItems.length > 0) {
        YouTubeIframeLoader.load(YT => {
            youtubeVideoItems.forEach(youtubeVideoItem => {
                // Skip if already initialized (double-check in case of race condition)
                if (youtubeVideoItem.hasAttribute('data-video-initialized')) return;

                youtubeVideoItem.setAttribute('data-video-initialized', 'true');
                const iframe = youtubeVideoItem.querySelector('[data-youtube-id]');
                if (!iframe) {
                    console.warn('initializeVideoItems: No iframe with data-youtube-id found', youtubeVideoItem);
                    return;
                }

                const ytvideoPlayer = new YT.Player(iframe.getAttribute('id'), {
                    videoId: iframe.getAttribute('data-youtube-id'),
                    events: {
                        onReady: () => {
                            new VideoItem(youtubeVideoItem, ytvideoPlayer);
                        }
                    }
                });
            });
        });
    }
};

const navigationInit = () => {
    if (mainNavigation) mainNavigation.init();

    let scrollTicking = false;
    document.addEventListener('scroll', () => {
        if (!scrollTicking) {
            scrollTicking = true;
            requestAnimationFrame(() => {
                if (mainNavigation) mainNavigation.scrollHandler();
                scrollTicking = false;
            });
        }
    });

    let resizeTimer: ReturnType<typeof setTimeout>;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (mainNavigation) mainNavigation.resizeHandler();
        }, 50);
    });
}

const initializeGenericComponents = () => {
    navigationInit();

    const panels = [].slice.call(document.querySelectorAll('[data-panel]')) as HTMLElement[];
    panels.forEach(panel => {
        new RevealPanel(panel);
    });

    const modals = Array.prototype.slice.call(document.querySelectorAll('[data-modal]')) as HTMLElement[];
    modals.forEach(modal => {
        new Modal(modal);
    });

    const accordions = [].slice.call(document.querySelectorAll('[data-accordion-list]')) as HTMLElement[];
    accordions.forEach(accordionEl => {
        const oneOpenAtATime = accordionEl.getAttribute('data-one-open-at-a-time') == "true";
        new Accordion({ container: accordionEl, oneOpenAtATime: oneOpenAtATime });
    });

    const tabEls = Array.prototype.slice.call(document.querySelectorAll('[data-tabs-container]')) as HTMLElement[];
    tabEls.forEach(tabEl => {
        new Tabs({ container: tabEl });
    })

    // Gallery Init
    document.addEventListener('DOMContentLoaded', function () {
        const galleryClass = 'gallery';
        const galleries = Array.prototype.slice.call(document.querySelectorAll('[data-gallery]'));
        galleries.forEach((gallery, index) => {
            gallery.classList.add(`${galleryClass}-${index}`);
            new Gallery(gallery);
        });
    });

    const quickDonateBlocks = [].slice.call(document.querySelectorAll('[data-quick-donate]'));
    quickDonateBlocks.forEach(block => {
        new QuickDonate(block);
    });

    // Header videos
    const headerVideoContainers = Array.prototype.slice.call(document.querySelectorAll('[data-header-video-container]')) as HTMLElement[];
    headerVideoContainers.forEach(HeaderVideoContainer => {
        new HeaderVideo(HeaderVideoContainer);
    });

    // Audio
    const audioItems = Array.prototype.slice.call(document.querySelectorAll('[data-audio-item]')) as HTMLElement[];
    audioItems.forEach(audioItem => {
        new AudioPlayer(audioItem);
    });

    // Videos - wrapped in DOMContentLoaded to ensure DOM is ready
    document.addEventListener('DOMContentLoaded', function () {
        initializeVideoItems();
    });

    // Videos
    const posterItems = Array.prototype.slice.call(document.querySelectorAll('[data-poster-id]')) as HTMLImageElement[];
    posterItems.forEach(poster => {
        new VideoPosterItem(poster);
    });

    //Filter Block Init
    const filterBlockInit = () => {
        const filterBlocks = Array.from(document.querySelectorAll('[data-filter-block]')) as HTMLElement[];
        if (filterBlocks.length > 0) {
            filterBlocks.forEach(filterBlock => {
                FilterAppInit(filterBlock)
            })
        }
    }
    filterBlockInit();
    const wordflyPage = document.getElementById("signUpModal");
    if (wordflyPage) {
        new WordflyModal(wordflyPage);
    }

    document.addEventListener('DOMContentLoaded', function () {
        // Privacy Alert
        let privacyEl = null;
        if (document.querySelector('[data-privacy-alert]')) {
            privacyEl = new privacyAlert(document.querySelector('[data-privacy-alert]') as HTMLElement);
        }
    });
    
}

initializeGenericComponents();
